import { makeStyles } from '@material-ui/styles';
import { CollapseLine, Theme } from '@bizzabo/design-system';

export interface ICollapseExpandProps {
    onClick: () => void;
}

const CollapseAppTools: React.FC<ICollapseExpandProps> = ({ onClick }) => {
    const classes = useStyles();
    return (
        <div className={classes.container} onClick={onClick}>
            <CollapseLine />
        </div>
    );
};

const useStyles = makeStyles<Theme>(
    () => ({
        container: {
            width: 20,
            height: 20,
            cursor: 'pointer',
        },
    }),
    {
        classNamePrefix: 'CollapseExpand',
    }
);

export default CollapseAppTools;
